
const Footer = () => {
    const creators = <>by <a herf=""></a> and <a herf=""></a></>
    const center = {
      "textAlign": "center"
    }

    return (
      <div style={center}>
        <b><i><a href="https://fullstackopen.com">FullStackOpen</a> 
        <a href="https://courses.helsinki.fi/fi/aytkt21010/133171831"> project</a> 2021-2026, University of Helsinki</i></b>
        <br />
        - new version of the project is mostly implemented by ai -
      </div>
    )
  }

  export default  Footer
